export default {
  'pages.zuzhijiegou': '组织结构',
  'pages.xinjiangongsi': '新建公司',
  'pages.xinjianbumen': '新建部门',
  'pages.xinjianchengyuan': '新建成员',
  'pages.jibenziliao': '基本资料',
  'pages.chengyuanliebiao': '成员列表',
  'pages.gongsimingcheng': '公司名称',
  'pages.gongsimiaoshu': '公司描述',
  'pages.zuihougengxinyu': '最后更新于',
  'pages.tijiaobingbaocungenggai': '提交并保存更改',
  'pages.xingming': '姓名',
  'pages.xingbie': '性别',
  'pages.zhuangtai': '状态',
  'pages.dengluming': '登录名',
  'pages.caozuo': '操作',
  'pages.bianji': '编辑',
  'pages.shanchu': '删除',
  'pages.queding': '确定',
  'pages.quxiao': '取消',
  'pages.bumen': '部门',
  'pages.jueseguanli': '角色管理',
  'pages.jueseliebiao': '角色列表',
  'pages.xinzengjuese': '新增角色',
  'pages.bianjijuese': '编辑角色',
  'pages.sousuo': '搜索',
  'pages.xuhao': '序号',
  'pages.juesemingcheng': '角色名称',
  'pages.quanxianxinxi': '权限信息',
  'pages.chengyuanshuliang': '成员数量',
  'pages.chengyuan': '成员',
  'pages.suoshugongsi': '所属公司',
  'pages.quanxianxiang': '权限项',
  'pages.chengyuanguanli': '成员管理',
  'pages.leixing': '类型',
  'pages.duixiang': '对象',
  'pages.xinzengchengyuan': '新增成员',
  'pages.bianjichengyuan': '编辑成员',
  'pages.gongsi': '公司',
  'pages.yichu': '移除',
  'pages.quanxianmingcheng': '权限名称',
  'pages.quanxianmiaoshu': '权限描述',
  'pages.api': 'API接口',
  'pages.miyaoxinxi': '密钥信息',
  'pages.jiekoumingcheng': '接口名称',
  'pages.qingqiufangfa': '请求方法',
  'pages.jiekoudizhi': '接口地址',
  'pages.jiekoumiaoshu': '接口描述',
  'pages.miyaomingcheng': '密钥名称',
  'pages.miyaoxinxi': '密钥信息',
  'pages.miaoshu': '描述',
  'pages.xiugaimima': '修改密码',
  'pages.jiumima': '旧密码',
  'pages.xinmima': '新密码',
  'pages.querenxinmima': '确认新密码',
  'pages.querenxiugai': '确认修改',
  'pages.mobanguanli': '模版管理',
  'pages.tishicimoban': '提示词模版',
  'pages.pptmoban': 'PPT模版',
  'pages.xinzengmoban': '新增模版',
  'pages.mobanmingcheng': '模版名称',
  'pages.shijian': '时间',
  'pages.bianjimoban': '编辑模版',
  'pages.tishicineirong': '提示词内容',
  'pages.shangchuanmoban': '上传模版',
  'pages.shangchuanwenjian': '上传文件',
  'pages.uploadmsg': '请上传PPT文件，大小在100M以内',
  'pages.yongyuji': '用语集',
  'pages.xinzeng': '新增',
  'pages.daoru': '导入',
  'pages.daochu': '导出',
  'pages.zhongwen': '中文',
  'pages.riwen': '日文',
  'pages.yingyu': '英语',
  'pages.hanyu': '韩语',
  'pages.yueyu': '粤语',
  'pages.xinzengyongyudui': '新增用语词汇',
  'pages.bianjiyongyudui': '编辑用语词汇',
  'pages.xinzengshuyu': '新增术语',
  'pages.bianjishuyu': '编辑术语',
  'pages.renliziyuan': '人力资源',
  'pages.logintitle': '欢迎回来',
  'pages.zhanghao': '账号',
  'pages.mima': '密码',
  'pages.yonghuming': '用户名',
  'pages.youxiang': '邮箱',
  'pages.chuangjianshijian': '创建时间',
  'pages.tuichudenglu': '退出登录',
  'pages.shangjibumen': '上级部门',
  'pages.bumenmingcheng': '部门名称',
  'pages.bumenmiaoshu': '部门描述',
  'pages.nan': '男',
  'pages.nv': '女',
  'pages.zaizhi': '在职',
  'pages.lizhi': '离职',
  'pages.querenshanchuma': '确认删除吗？',
  'pages.shanchutixing': '删除提醒',
  'pages.permission_name1': '组织结构维护',
  'pages.permission_desc1': '允许查看/新增/编辑/封存部门、成员',
  'pages.permission_name2': '角色维护',
  'pages.permission_desc2': '可以查看/新增/编辑/删除',
  'pages.permission_name3': '权限项查看',
  'pages.permission_desc3': '查看权限项列表',
  'pages.permission_name4': '会议实时翻译',
  'pages.permission_desc4': '允许使用会议实时翻译功能模块',
  'pages.permission_name5': '文档智能处理',
  'pages.permission_desc5': '允许使用文档智能处理功能模块',
  'pages.permission_name6': '内容自动生成',
  'pages.permission_desc6': '允许使用内容智能生成功能模块',
  'pages.permission_name7': '模版维护',
  'pages.permission_desc7': '可以查看/新增/编辑/删除',
  'pages.permission_name8': '用语集维护',
  'pages.permission_desc8': '可以查看/新增/编辑/删除',
  'pages.permission_name9': '审计日志查看',
  'pages.permission_desc9': '可以查看审计日志',
  'pages.permission_name10': 'API密钥维护',
  'pages.permission_desc10': '可以查看/编辑API密钥',
  'pages.permission_name11': '热词维护',
  'pages.permission_desc11': '可以查看/新增/删除',
  'pages.permission_name12': '术语干预维护',
  'pages.permission_desc12': '可以查看/新增/编辑/删除',
  'pages.permission_name13': '统计报表查看',
  'pages.permission_desc13': '可以查看会议点赞点踩报表',
  'pages.permission_name14': '版本配置维护',
  'pages.permission_desc14': '可以查看/编辑各应用模块版本配置',
  'pages.permission_name15': '会议主题限制',
  'pages.permission_desc15': '可以查看/编辑会议主题长度限制',
  'pages.shangchuanchenggong': '上传成功',
  'pages.shangchuanshibai': '上传失败',
  'pages.mobantixing': '模版导入中，请稍等...',
  'pages.zhongguoluosen': '中国罗森',
  'pages.guanjianci': '关键词',
  'pages.pptuploadmsg': '请上传符内容格式的xlsx文件',
  'pages.gonghao': '工号',
  'pages.shouji': '手机',
  'pages.weihuren': '维护人',
  'pages.yuanwenjian': '文件位置',
  'pages.shengchengwenjian': '生成文件',
  'pages.caozuoren': '操作人',
  'pages.isPPT': '只能上传 ppt 文件',
  'pages.20M': '最大支持100M',
  'pages.isXLSX': '只能上传 xlsx 文件',
  'pages.shoujiguize': '请输入正确手机号',
  'pages.gongsimingchengyicunzai': '公司名称已存在',
  'pages.bumenmingchengyicunzai': '部门名称已存在',
  'pages.denglumingyicunzai': '登录名已存在',
  'pages.youxiangyicunzai': '邮箱已存在',
  'pages.shoujiyicunzai': '手机已存在',
  'pages.gonghaoyicunzai': '工号已存在',
  'pages.juesemingchengyicunzai': '角色名称已存在',
  'pages.yicunzai': '已存在',
  'pages.pwd_expired_days': '密码有效期',
  'pages.pwd_length_min': '密码最小长度',
  'pages.pwd_length_max': '密码最大长度',
  'pages.pwd_complexity': '密码复杂度',
  'pages.lock_error_num': '锁定错误次数',
  'pages.lock_error_minutes': '锁定时长',
  'pages.buxianzhi': '不限制',
  'pages.fuza': '大写、小写、数字、特殊符号，必须有4种',
  'pages.yanzhengma': '验证码',
  'pages.getyanzhengma': '获取验证码',
  'pages.okyanzhengma': '验证码发送成功',
  'pages.failyanzhengma': '验证码发送失败',
  'pages.tian': '天',
  'pages.wei': '位',
  'pages.ci': '次',
  'pages.fenzhong': '分钟',
  'pages.null': '禁止输入空格',
  'confirmpwd': '确认密码错误',
  'pages.loginusername': '登录管理平台的账号',
  'pages.loginpwd': '登录管理平台的密码',
  'pages.code_expired': '验证码错误或已过期',
  'pages.login_error1': '账号或密码错误',
  'pages.login_error2': '密码已过期，请点击忘记密码进行重置',
  'pages.error_more1': '错误次数超过',
  'pages.error_more2': '次,账号已被锁定，请点击忘记密码进行重置或等待',
  'pages.error_more3': '分钟后重试',
  'pages.xiugaichenggong': '修改成功',
  'pages.shanchuchenggong': '删除成功',
  'pages.yicunzai': '存在重复用语集',
  'pages.gaizuzhineimeiyouyonghu': '该组织内没有用户',
  'pages.mobanmingchengyicunzai': '模版名称已存在',
  'pages.moban_scope': '模板范围',
  'pages.gonggongmoban': '公共模板',
  'pages.gongsimoban': '公司模板',
  'pages.baohanxiashugongsi': '包含下属公司',
  'pages.shiyongxiashugongsi': '适用于下属公司',
  'pages.qingxuanzegongsi': '请选择所属公司',
  'pages.xiazai': '下载',
  'pages.gonggong': '公共',
  'pages.geren': '个人',
  'pages.cunzaibumenchengyuan': '存在部门或成员，无法删除',
  'pages.cunzaichengyuan': '存在成员，无法删除',
  'pages.xiazaimoban': '下载模版',
  'pages.suijishengcheng': '随机生成',
  'pages.zonggong': '总共',
  'pages.tiao': '条',
  'pages.chongzhi': '重置',
  'pages.huiyizhuti': '会议主题',
  'pages.yuyanzuhe': '语言组合',
  'pages.huiyishijian': '会议时间',
  'pages.fankuileixing': '反馈类型',
  'pages.fankuiyuanyin': '反馈原因',
  'pages.fankuishijian': '反馈时间',
  'pages.sucaiyulan': '素材预览',
  'pages.sucaimingcheng': '素材名称',
  'pages.sucailujing': '素材路径',
  'pages.xinzengsucai': '新增素材',
  'pages.bianjisucai': '编辑素材',
  'pages.tongleixingzhinengqiyongyitiao': '同一种反馈类型只能启用一条素材',
  'pages.qiyong': '启用',
  'pages.tingyong': '停用',
  'pages.paixu': '排序',
  'pages.zan': '赞',
  'pages.cai': '踩',
  'pages.jiazaishibai': '加载失败',
  'pages.baocunchenggong': '保存成功',
  'pages.baocunshibai': '保存失败',
  'pages.yiyingyong': '已应用',
  'pages.bianjibanben': '编辑版本',
  'pages.yingyongmingcheng': '应用名称',
  'pages.banbenhao': '版本号',
  'pages.meetingTopicLimitTitle': '会议主题限制',
  'pages.meetingTopicLimitEnable': '启用规则',
  'pages.meetingTopicLimitZh': '中文字符上限',
  'pages.meetingTopicLimitEn': '英文字符上限',
  'pages.meetingTopicLimitDigit': '数字上限',
  'pages.meetingTopicLimitOther': '其他字符上限',
  'pages.meetingTopicLimitTotal': '总字符上限',
  'pages.meetingTopicLimitBytesHint': '无论如何，总长度都不能超过 {bytes} bytes；留空表示不限制。',
  'pages.meetingTopicLimitNoticeZh': '中文提示文案',
  'pages.meetingTopicLimitNoticeZhPlaceholder': '留空时使用系统默认中文提示',
  'pages.meetingTopicLimitNoticeJa': '日文提示文案',
  'pages.meetingTopicLimitNoticeJaPlaceholder': '留空时使用系统默认日文提示',
  'pages.meetingTopicLimitSave': '保存配置',
  'pages.meetingTopicLimitDisabled': '当前未启用规则',
  'pages.faburiqi': '发布日期',
  'pages.kaiqi': '开启',
  'pages.guanbi': '关闭',
  'pages.shifouxianshibanben': '显示版本号',
  'pages.fabuxinbanben': '发布新版本',
  'pages.fabuchenggong': '发布成功',
  'pages.lishibanben': '历史版本',
  'pages.zanwulishibanben': '暂无历史版本',
  'pages.zuixinneirong': '最新更新内容',
  'pages.zanwugengxinneirong': '暂无更新内容',
  'pages.gongnengqingdan': '功能清单',
  'pages.qingshurugongnengqingdan': '请输入功能清单',
  'pages.gongnengqingdanplaceholder': '请填写本次发版更新的功能清单，建议一行一条',
  'pages.geshicuowu': '文件格式错误',
  'pages.uploadpic': '请上传 jpg、png 图片',
  'pages.updateHot': '更新热词',
  'pages.hotname': '热词名称',
  'pages.hotTips': '提示：多个提示词用英文逗号拼接。',

  'pages.AI_API_KEY': '千问大模型ApiKey',
  'pages.AI_WORKSPACE_ID': '百炼业务空间ID',
  'pages.AI_KB_ID': '知识库ID',
  'pages.AL_KEY_ID': '阿里云aceess_key_id',
  'pages.AL_KEY_SECRET': '阿里云aceess_key_secret',
  'pages.QIWEI_ID': '企业微信ID',
  'pages.QIWEI_SECRET': '实时会议应用密钥',
  'pages.QIWEI_SECRET2': '文档智能处理密钥',
  'pages.QIWEI_SECRET': '内容生成密钥',
 

  'pages.layouts.userLayout.title': '请输入您的凭证以访问系统后台',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.gonghaoemail': '工号或邮箱',
  'pages.queren': '确认',
  'pages.yuyan': '语言'
  
};
